/* eslint-disable */
const config = {
  // apiHost: "https://slidespielportalsapi.azurewebsites.net",
  apiHost: "https://slidespielportalsapitest.azurewebsites.net",
  spmApiHost: "https://slidespielspeakersapi.azurewebsites.net",
  chatRealm: "https://chat.slidespiel.com",
  env: "development",
  portalName: "fma-ce",
  title: "FMA Annual Meeting",
  questionsBeforeRecording: false,
  portals: [
    { year: 2022, id: "d90056bf-0484-4e56-ad7f-9cd78c61ff32" },
  ],
  defaultYear: 2022,
  version: "1.3.3",
};

if (process.env.NODE_ENV === "production") {
  Object.assign(config, {
    apiHost: "https://slidespielportalsapi.azurewebsites.net",
    env: "production",
    sentryDsn: "https://66ebec47e0014dccb50af5e51f5348eb@o361175.ingest.sentry.io/5264442",
  });
}


export default config;
